module.exports = __webpack_public_path__ + "static/media/Bakery-01.cf6b481c.svg";